export default {
    NETWORK_SETUP: 'NETWORK_SETUP',
    CUSTOMER_SETUP: 'CUSTOMER_SETUP'
}